<template>
    <ListingSettingsHeader
        searchable
        :searchValue="searchValue"
        :filters="filters"
        displayTotalResults
        :totalResults="totalResults"
        @search="searchAttributes"
        @selectFilter="updateActiveFilters"
    >
        <template #filters>
            <template v-for="activeFilter in getActiveFilters">
                <ListingFilterSelect
                    v-if="activeFilter.components === 'ListingFiltersSelect'"
                    :key="activeFilter.code"
                    :filter="activeFilter"
                    @update:displayDropdown="(value) => displayDropdown(activeFilter, value)"
                    @updateFilter="(values) => updateFilter(activeFilter, values)"
                    @removeFilter="removeActiveFilter(activeFilter)"
                />
            </template>
        </template>
    </ListingSettingsHeader>
</template>

<script>
import ListingFilterSelect from 'vcomponents/common/listing/filters/types/ListingFiltersSelect.vue';
import ListingSettingsHeader from 'vcomponents/common/listing/header/ListingSettingsHeader.vue';

export default {
    components: {
        ListingFilterSelect,
        ListingSettingsHeader,
    },
    props: {
        searchValue: {
            type: String,
            default: '',
        },
        filters: {
            type: Array,
            required: true,
        },
        totalResults: {
            type: Number,
            default: 0,
        },
    },
    computed: {
        getActiveFilters() {
            return this.filters.filter((filter) => filter.isActive);
        },
    },
    methods: {
        searchAttributes(value) {
            this.$emit('search', value);
        },
        updateFilter(filterToUpdate, filterValue) {
            this.$emit('updateFilter', {
                filterCode: filterToUpdate.code,
                filterValue: filterValue,
                filterOptionsSelected: filterValue,
            });
        },
        updateActiveFilters(filter) {
            this.$emit('updateActiveFilters', {
                ...filter,
                isActive: true,
                displayDropdown: true,
            });
        },
        removeActiveFilter(filter) {
            this.$emit(
                'updateActiveFilters',
                {
                    ...filter,
                    value: [],
                    optionsSelected: [],
                    isActive: false,
                    displayDropdown: true,
                },
                filter.value.length > 0,
            );
        },
        displayDropdown(filter, value) {
            filter.displayDropdown = value;
        },
    },
};
</script>
